<template>
  <div class="mt-3" v-show="chartseries.length > 0">
    <div class="d-flex">
      <h2 class="titleText--text">Variable execution over time</h2>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-icon  v-bind="attrs" size="medium"
          v-on="on" color="blue" class="ml-3 mt-1">mdi-information-outline</v-icon>
        </template>
        <span> Variable execution over time</span>
      </v-tooltip>
    </div>
    <v-card flat class="custom-shadow mt-2">
      <v-card-text>
        <div>
          <div style="min-width: 300px">
            <search-select-box v-model="selectedSeries" :items="variableNames"/>
          </div>
          <div class="d-flex">
            <v-checkbox
              v-model="chartsFilter"
              value="Value"
              @change="getchartseries"
              class="ml-3"
              color="#2CD8C5"
              on-icon="mdi-checkbox-marked-circle"
              off-icon="mdi-checkbox-blank-circle-outline"
            >
              <template v-slot:label>
                <span
                  class="titleText--text font-weight-bold text-capitalize"
                  style="font-size: 14px"
                  >{{ variableItems[0] }}</span
                >
              </template>
            </v-checkbox>
            <v-checkbox
              v-model="chartsFilter"
              value="Volume"
              @change="getchartseries"
              class="ml-3"
              color="#2CD8C5"
              on-icon="mdi-checkbox-marked-circle"
              off-icon="mdi-checkbox-blank-circle-outline"
            >
              <template v-slot:label>
                <span
                  class="titleText--text font-weight-bold text-capitalize"
                  style="font-size: 14px"
                  >{{ variableItems[1] }}</span
                >
              </template>
            </v-checkbox>
          </div>
        </div>
        <v-row>
          <v-col md="12">
            <div id="chart">
              <apexchart
                style="z-index: 0px !important"
                height="350"
                ref="chart"
                :options="chartOptions"
                :series="filteredSeries"
              ></apexchart>
            </div>
          </v-col> </v-row
      ></v-card-text>
    </v-card>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import apifactory from "../api";
import SearchSelectBox from '@/components/SearchSelectBox.vue'
//import AppWidget from "../../../components/AppWidget.vue";
export default {
  components: {
    apexchart: VueApexCharts,
    SearchSelectBox
  },
  props: {
    options: {
      type: [],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    ishavedata: {
      type: Boolean,
      required: true,
    },
    regionlist: {
      type: [],
      required: true,
    },
  },
  data: () => ({
    itemlist: [],
    strnodatafount: "No Data Found",
    ishavedata: false,
    level: "",
    levelSubNation: "subnational",
    issubnation: false,
    columndesc: [],
    colmnsname: [],
    selectedSeries: [],
    variableNames: [],

    //for chart
    prevstepQueryStringParm: [],
    prevstepQueryStringParmUrl: "",
    //filtervalue
    Independentvariables: [],
    IndependentvariablesSelected: [],
    //end
    // for dropdown
    variableItems: [],
    chartsFilter: ["Value", "Volume"],
    chartsFilterNew: [],
    //end
    //for chart
    itemsplot: [],
    series: [],
    seriesfinal: [],
    chartseries: [],
    chartshow: 0,
    chartOptions: [],

    xaxismin: null,
    xaxismax: null,
    //end
    tempdatalist: [],
    listofregion: [],
    dataregionSelected: null,
    searchTerm: '',
    copiedVariables: []
  }),
  methods: {
    removeSelectesSeries (value) {
      this.selectedSeries = this.selectedSeries.filter(item => value !== item)
    },
    searchItems() {
      if (!this.searchTerm) {
        this.variableNames = [...this.copiedVariables]
      }

      this.variableNames = this.copiedVariables.filter((fruit) => {
        return fruit.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
      });
    },
    refresh(vardataregionSelected) {
      //alert('graph' +vardataregionSelected);
      this.dataregionSelected = vardataregionSelected;
      this.title = vardataregionSelected;
      this.loadData();
      this.getchartseries();
    },

    loadData() {
      this.callApi_call_save_step3();
    },
    callApi_call_save_step3() {
      apifactory
        .call_save_step3()
        .then(() => {
            this.loaddataOnGrid();
        })
        .catch(function (error) {
          console.error(error.message)
        });
    },
    loaddataOnGrid() {
      apifactory
        .call_get_step3_output()
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            this.cleardata();

            this.columndesc = res.data.column_description;
            this.level = res.data.project_level;
            this.colmnsname = [...Object.keys(res.data.data[0])];
            this.itemlist = res.data.data;
            //alert(this.level);
            if (this.level == "subnational") {
              this.isdatasublevel = true;
            } else {
              this.isdatasublevel = false;
            }
            //alert( this.isdatasublevel);
            this.ishavedata = true;

            // let temparray=[];
            // temparray=[...Object.keys(res.data.data[0])];

            this.variableItems = this.getvariableItems();
            this.Independentvariables = this.getIndependentvariables(); //temparrayIndependentvariables;
            let tempIndependentvariables=[];
            tempIndependentvariables=this.getIndependentvariables(); 
            this.IndependentvariablesSelected =tempIndependentvariables;//.slice(0,4) ;// this.getIndependentvariables(); //temparrayIndependentvariables;
            if (this.isdatasublevel) {
              this.itemsplot = res.data.data.filter(
                (a) => a.region == this.dataregionSelected
              );
            } else {
              this.itemsplot = res.data.data;
            }
            //this.itemsplot =res.data.data;// res.data.data.filter((a) => a.region == "region1");
            //alert('done');
            this.tempdatalist = this.filteredDatatemp();
            // alert('tempdatalist');
            this.getchartseries();
          }
        })
        .catch(function () {
          // alert(error);
          // return false;
        });
    },
    cleardata() {
      this.variableItems = [];
      // this.chartsFilter = [];
      this.Independentvariables = [];
      this.IndependentvariablesSelected = [];
      this.itemsplot = [];
      this.tempdatalist = [];
    },
    getprojectregions() {
      apifactory
        .call_get_project_region_list()
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            //alert(JSON.stringify(res.data));
            this.listofregion = res.data;
          }
        })
        .catch(function () {
          // alert("getprojectregions" + error);
          // return false;
        });
    },
    getvariableItems() {
      let temparray = [];
      temparray.push("sales");
      temparray.push("volume");
      return temparray;
    },
    getIndependentvariables() {
      let temparray = [];
      temparray = [...Object.keys(this.itemlist[0])];
      return temparray.filter(
        (a) =>
          a.toString() != this.columnfullName("sales_value") &&
          a.toString() != this.columnfullName("sales_volume") &&
          a.toString() != "region"
      );
    },
    filteredDatatemp() {
      const filterKeys = this.IndependentvariablesSelected;
      return this.itemsplot.filter((key) => filterKeys.includes(key));
    },

    getchartseries() {
      var keys = [];
      var tkey = [];
      var datelist = [];
      for (var k1 in this.itemsplot[0]) {
        if (k1 != "date") {
          keys.push(k1);
          var obj = new Object();
          obj.name = k1;
          var keysdata = [];

          for (var i = 0; i < this.itemsplot.length; i++) {
            datelist.push(new Date(this.itemsplot[i].date).getTime());
            var innerdata = [];
            innerdata.push(new Date(this.itemsplot[i].date).getTime());
            innerdata.push(this.itemsplot[i][k1]);
            keysdata.push(innerdata);
          }

          obj.data = keysdata;

          tkey.push(obj);
        }
      }

      this.seriesfinal = [];
      this.series = [];
      this.series = tkey;
       this.chartsFilterNew=[];
      for (let el in this.chartsFilter) {
         if (this.chartsFilter[el] == "Value") {
          this.chartsFilterNew.push(this.columnfullName("sales_value"));
       
        }
        if (this.chartsFilter[el] == "Volume") {
          this.chartsFilterNew.push(this.columnfullName("sales_volume"));
       
        }
      }
      for (let el in this.series) {
        if (this.chartsFilterNew.includes(this.series[el].name)) {
          this.series[el].type = "line";
          this.seriesfinal.push(this.series[el]);
        }
      }

      for (let el in this.series) {
        for (let k in this.IndependentvariablesSelected) {
          if (this.series[el].name === this.IndependentvariablesSelected[k]) {
            this.series[el].type = "bar";
            this.seriesfinal.push(this.series[el]);
          }
        }
      }

      let datelistarray = [];

      datelistarray = datelist;

      let maxdate = Math.max.apply(Math, datelistarray);
      let mindate = Math.min.apply(Math, datelistarray);
      this.xaxismin = mindate;
      this.xaxismax = maxdate;
      this.chartseries = [];
      this.selectedSeries = this.seriesfinal.slice(0, 5).map(item => item.name)
      this.chartseries = this.seriesfinal.filter(item => this.selectedSeries.includes(item.name))
      this.variableNames = this.seriesfinal.map(item => item.name)
      this.copiedVariables = [...this.variableNames]

      this.chartOptions = {
        chart: {
          height: 350,
          type: "line",
          stacked: false,

          toolbar: {
            show: true,
            offsetX: -100,
            offsetY: 0,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [1, 1],
        },
        xaxis: {
          type: "datetime",
          min: mindate,
          max: maxdate,
          tickAmount: 6,
        },

        yaxis: this.tempchartoptionnew(),
        tooltip: {
          fixed: {
            enabled: true,
            position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60,
          },
        },
        legend: {
          horizontalAlign: "center",
          offsetX: 40,
        },
      };
      this.chartshow = 1;
    },
    fetchVaribles(varfilterlist) {
      //alert('testfetchVaribles' + varfilterlist);
      this.variableItems = varfilterlist;
    },
    filteredChartsfinalseries() {
      let data = [];

      for (let el in this.series) {
        // alert(this.series[el].name);
        for (let k in this.IndependentvariablesSelected) {
          //alert("dd"+this.chartsFilter[k]);
          if (this.series[el].name === this.IndependentvariablesSelected[k]) {
            //alert(JSON.stringify(this.series[el]));
            data.push(this.series[el]);
          }
        }
      }
      return data;
    },
    tempchartoptionnew() {
      let outputwithbase = [];
      let output = [];
      let issecondaxis = false;

      for (let el in this.chartseries) {
       
        for (let k in this.chartsFilterNew) {
       
          if (this.chartseries[el].name === this.chartsFilterNew[k]) {
            issecondaxis = true;
            let objone1 = [
              {
                opposite: issecondaxis,
                axisTicks: {
                  show: true,
                },
                axisBorder: {
                  show: true,
                  color: "#008FFB",
                },
                labels: {
                  style: {
                    colors: "#008FFB",
                  },

                  formatter: function (val) {
                    return val.toLocaleString("en-US");
                  },
                },
                title: {
                  text: this.chartseries[el].name,
                  style: {
                    color: "#008FFB",
                  },
                },
                tooltip: {
                  enabled: true,
                },
              },
            ];
            output.push(objone1[0]);
          }
        }
      }
      let objone = [
        {
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: "#008FFB",
          },
          labels: {
            style: {
              colors: "#008FFB",
            },
            formatter: function (val) {
              return val.toLocaleString("en-US");
            },
          },
          title: {
            text: "Variables",
            style: {
              color: "#008FFB",
            },
          },
          tooltip: {
            enabled: true,
          },
        },
      ];

      output.push(objone[0]);
      outputwithbase.push(output);
      return output;
    },
    chartoptionbase() {
      let baseoption = [];
      baseoption = [
        {
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: "#008FFB",
          },
          labels: {
            style: {
              colors: "#008FFB",
            },
          },
          title: {
            text: "CPP",
            style: {
              color: "#008FFB",
            },
          },
          tooltip: {
            enabled: true,
          },
        },
      ];
      return baseoption;
    },
  },
  computed: {
    filteredSeries () {
      return this.seriesfinal.filter(item => this.selectedSeries.includes(item.name))
    },
    columnfullName() {
      return (theParam) => {
        let desc = [];
        desc = this.columndesc.filter((a) => a.description == theParam);
        return desc[0].column;
      };
    },
    fullName() {
      return (theParam) => {
        let desc = [];
        desc = this.columndesc.filter((a) => a.column == theParam);
        return desc[0].description;
      };
    },
    fullNamecolumn() {
      return (theParam) => {
        let desc = [];
        desc = this.columndesc.filter((a) => a.column == theParam);

        return desc[0].description;
      };
    },
    isdatasublevel() {
      if (this.level === this.levelSubNation) {
        return true;
      } else {
        return false;
      }
    },
    //for chart
    filteredChartsData1() {
      let data = [];

      for (let el in this.series) {
        // alert(this.series[el].name);
        for (let k in this.IndependentvariablesSelected) {
          //alert("dd"+this.chartsFilter[k]);
          if (this.series[el].name === this.IndependentvariablesSelected[k]) {
            //alert(JSON.stringify(this.series[el]));
            data.push(this.series[el]);
          }
        }
      }
      return data;
    },
    filteredChartsData() {
      let data = [];

      for (let el in this.series) {
        // alert(this.series[el].name);
        data.push(this.series[el]);
      }
      return data;
    },
  },
  mounted() {
    this.getprojectregions();
    this.refresh(this.title);
    this.copiedVariables = [...this.variableNames]
  }
};
</script>